import { fetchAPI } from '@/services/prismic';
import { camelize } from '@/scripts/camelize';
import { fetchBannerContent } from './shared/banner';
import { fetchHighlightsContent } from './shared/highlights';

const getSpanishOnsiteProgramsQuery = `
query getSpanishOnsitePrograms {
  allSpanish_onsite_programs_pages {
    edges {
      node {
        meta_title 
        meta_description
        top_banner {
          ... on Top_banner {
            title
            sub_title
            background_image
          }
        }
        rich_text
        program_highlights {
          ... on Costa_rica_highlights {
            _meta {
              id
            }
          }
        }
        programs_title
        programs_subtitle
        programs_intro
        other_programs_title
        other_programs_subtitle
        banner {
          ... on Banner {
            _meta {
              id
            }
          }
        }
        acommodation_banner {
          ... on Banner {
            _meta {
              id
            }
            background_image
            items {
             item {
               ... on Banner_card {
                 title
                 buttons {
                   primary_button {
                     ... on Call_to_action {
                       title
                       type
                       style
                       url
                       open_in_another_page
                     }
                   }
                 }
               }
             }
           }
          }
        }
        banner1 {
           ... on Banner {
            _meta {
              id
            }
          }
        }
        perfect_locations {
          ... on Perfect_location {
            title
            sub_title
            locations {
              location {
                ... on Location {
                  title
                  city
                  location_name
                  description
                  call_to_actions {
                    call_to_action {
                      ... on Call_to_action {
                        title
                        type
                        style
                        url
                        open_in_another_page
                      }
                    }
                  }
                  images {
                    image
                  }
                }
              }
            }
          }
        },
        simple_banner {
          ... on Simple_banner {
            title,
            primary_button {
              ... on Call_to_action {
                title
                type
                style
                url
                open_in_another_page
              }
            }
          }
        }
        bring_a_group {
          ... on Style_card {
            title
            card_content {
              ... on Styled_card_content {
                title
                sub_title
                description
                content_alignment
              }
            }
            image
          }
        }
        why_bring_a_group {
          ... on Style_card {
            title
            card_content {
              ... on Styled_card_content {
                title
                sub_title
                description
                buttons {
                  button {
                    ... on Call_to_action {
                      title
                      type
                      style
                      url
                      open_in_another_page
                    }
                  }
                }
                content_alignment
              }
            }
            image
          }
        }
      }
    }
  }
}
`;

export const fetchSpanishOnsiteProgramsContent = async previewData => {
  const {
    allSpanish_onsite_programs_pages: {
      edges: [{
        node: spanishOnsiteProgramsContent,
      } = {}] = [],
    } = {},
  } = await fetchAPI(getSpanishOnsiteProgramsQuery, {
    previewData,
  });

  const banner = await fetchBannerContent(spanishOnsiteProgramsContent.banner._meta.id, previewData);
  const banner1 = await fetchBannerContent(spanishOnsiteProgramsContent.banner1._meta.id, previewData);
  const programHighlights = await fetchHighlightsContent(spanishOnsiteProgramsContent.program_highlights._meta.id, previewData);

  return camelize({
    ...spanishOnsiteProgramsContent,
    banner,
    banner1,
    programHighlights,
  });
};

export const getPerfectLocationsContent = content => {
  const perfectLocations = JSON.parse(
    JSON.stringify(content.perfectLocations)
  );

  const locations = perfectLocations.locations.reduce(
    (accumulator, currentValue) => {
      const location = {
        ...currentValue.location,
        title: `${currentValue?.location?.city} ${currentValue?.location?.locationName}`,
        image: currentValue?.location?.images[0].image,
      }
      
      const card = {
        card: {
          ...location,
        },
      };

      accumulator.push(card);

      return accumulator;
    },
    []
  );
  perfectLocations.cards = [...locations];

  return perfectLocations;
}